import { type FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useForgotPassword } from '@/hooks/useAuth';
import { getApiErrorMessage } from '@/api/client';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { Alert } from '@/components/ui/Alert';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState<string>();
  const forgotPassword = useForgotPassword();

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) {
      setEmailError('Vnesite veljaven e-poštni naslov.');
      return;
    }
    setEmailError(undefined);
    await forgotPassword.mutateAsync(email.trim()).catch(() => undefined);
  }

  if (forgotPassword.isSuccess) {
    return (
      <div className="flex flex-col gap-4">
        <h1 className="text-lg font-semibold text-fg">Preverite e-pošto</h1>
        {/* Same answer whether or not the address has an account, so this page cannot be used to find out who is registered. */}
        <Alert variant="success">
          Če je za naslov {email.trim()} registriran račun, smo nanj poslali povezavo za ponastavitev gesla. Povezava
          velja eno uro.
        </Alert>
        <p className="text-sm text-fg-muted">
          Sporočila ni? Preverite mapo z neželeno pošto ali poskusite znova čez nekaj minut.
        </p>
        <Link to="/login" className="text-center text-sm font-medium text-accent-text hover:underline">
          Nazaj na prijavo
        </Link>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} noValidate className="flex flex-col gap-4">
      <div>
        <h1 className="text-lg font-semibold text-fg">Pozabljeno geslo</h1>
        <p className="mt-1 text-sm text-fg-muted">
          Vnesite e-pošto svojega računa in poslali vam bomo povezavo za nastavitev novega gesla.
        </p>
      </div>

      {forgotPassword.isError && <Alert variant="error">{getApiErrorMessage(forgotPassword.error)}</Alert>}

      <Input
        label="E-pošta"
        type="email"
        name="email"
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        error={emailError}
      />

      <Button type="submit" isLoading={forgotPassword.isPending} className="w-full">
        Pošlji povezavo
      </Button>

      <Link to="/login" className="text-center text-sm font-medium text-accent-text hover:underline">
        Nazaj na prijavo
      </Link>
    </form>
  );
}
